import { AutogenLayoutFuelSurchargeCycleCodesList } from "./autogen/AutogenLayoutFuelSurchargeCycleCodesList";
import { ClickEvent, TableRow } from "@mcleod/components";

export class FuelSurchargeCycleCodesList extends AutogenLayoutFuelSurchargeCycleCodesList {

    onLoad() {
        this.mainDataSource.search();
    }
}
